import { render, staticRenderFns } from "./OrganisationPage.vue?vue&type=template&id=4b938614&scoped=true"
import script from "./OrganisationPage.vue?vue&type=script&lang=js"
export * from "./OrganisationPage.vue?vue&type=script&lang=js"
import style0 from "./OrganisationPage.vue?vue&type=style&index=0&id=4b938614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b938614",
  null
  
)

export default component.exports